// Parse a date string as a LOCAL calendar date so YYYY-MM-DD never shifts a day
// due to timezone conversion (e.g. Oct 18 must always show as Oct 18).
export function parseLocalDate(s) {
  if (!s) return null;
  if (typeof s === "string") {
    const parts = s.slice(0, 10).split("-");
    if (parts.length === 3) return new Date(+parts[0], +parts[1] - 1, +parts[2]);
  }
  return new Date(s);
}

export function fmtDate(s) {
  const d = parseLocalDate(s);
  return d ? d.toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" }) : "";
}

export function daysUntil(s) {
  const d = parseLocalDate(s);
  if (!d) return 0;
  return Math.max(0, Math.ceil((d - new Date()) / 86400000));
}
